export const API_URL = process.env.REACT_APP_API_URL;
export const SITE_URL = process.env.REACT_APP_SITE_URL;
export const BUFFER_TIME_STAFF = process.env.BUFFER_TIME_FOR_STAFF;


export const STARTING_PRICE_HOUSE_CLEANING = process.env.REACT_APP_STARTING_PRICE_HOUSE_CLEANING;
export const STARTING_TIME_HOUSE_CLEANING = process.env.REACT_APP_STARTING_TIME_HOUSE_CLEANING;

